import { render, staticRenderFns } from "./GpAddPage.vue?vue&type=template&id=1f785452&scoped=true&"
import script from "./GpAddPage.vue?vue&type=script&lang=js&"
export * from "./GpAddPage.vue?vue&type=script&lang=js&"
import style0 from "./GpAddPage.vue?vue&type=style&index=0&id=1f785452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f785452",
  null
  
)

export default component.exports